export default "__VITE_ASSET__a6d4470d__"